import { getCssVariableValue } from "../../../utils/utils.js";
import store from "@/store/index.js";
import {
  STORE_TYPE_NORMAL,
  STORE_TYPE_GENERAL,
  STORE_TYPE_STAR,
  STORE_TYPE_PLANET,
} from "../../../utils/const";

function getPosition(position) {
  let className = "";
  switch (position) {
    case "L":
      className = "long";
      break;
    case "S":
      className = "short";
      break;
  }

  return className;
}

export const coinFormatter = (cell) => {
  const value = cell.getValue().replace("USDT", "");
  // const value =cell.getValue();
  // console.log('coin',value);

  const coinArr = store.getters["userInfo/favoriteList"];

  // const imgSrc  = require(`@/assets/image/coin_logos/${value.toLowerCase()}.png`);
  const isActive = coinArr.includes(value) ? "active" : "";
  // console.log('coinFormmater coinArr',coinArr,'isActive',isActive);

  return `
        <section style="display: flex; align-items: center; justify-content: center; height: 100%">
            <img src="${getImageSrc(
              value
            )}" alt="${value}_icon" style="width: 24px; height: 24px"/>
            <span style="margin-left: 10px">${value}</span>
            <div class="star ${isActive}"></div>
        </section>
    `;
};

export function getImageSrc(value) {
  const baseUrl =
    "https://risingx-wedatalab.s3.ap-northeast-2.amazonaws.com/static/coin_icon/";
  const imgSrc = `${baseUrl}${value}.png`;

  // 이미지가 제대로 로드되지 않으면 기본 이미지로 대체
  return imgSrc || `${baseUrl}default.png`;
}

export const numberColorFormatter = (cell) => {
  const field = cell.getField();
  const val = Number(cell.getValue()) || 0;

  if (val === 0 || val > 0) {
    cell.getElement().style.color = getCssVariableValue("--main");
  } else {
    cell.getElement().style.color = getCssVariableValue("--red-100");
  }

  if (field.includes("percent")) {
    return `<span>${val}%</span>`;
  } else if (field.includes("price")) {
    return `<span>${Number(val).toFixed(2)}</span>`;
  } else {
    return `<span>${val}</span>`;
  }
};

export const coinTitleFormatter = (cell) => {
  return `
        <div class="coin-header">
            <span class="star"></span>
            <span class="title">${cell.getValue()}</span>
        </div>
    `;
};

export const timeTitleFormatter = (cell) => {
  const val = cell.getValue();
  return `
        <div style="display:flex; align-items:center; justify-content:center;">
            <span>${val}</span>
            <div class="symbol-wrapper">
                <span class="long highlight__400;"></span>
                <span class="short highlight__400;"></span>
            </div>
        </div>
    `;
};

export const rsiFormatter = (cell) => {
  const data = cell.getData();
  // console.log('data',data);

  const time = data["time"] || "";
  const position = data["position"];
  const className = getPosition(position);

  return `
        <div class="position-wrapper">
            <span>${time}</span>
            <span class="${className} highlight__400;"></span>
        </div>
    `;
};

export const fixedFormatter = (cell) => {
  const data = cell.getValue();

  let className = "";
  switch (data) {
    case "L":
      className = "long";
      break;
    case "S":
      className = "short";
      break;
  }
  return `<span class="${className} highlight__400;"></span>`;
};

export const arrowFormatter = (cell) => {
  const data = cell.getValue();
  let arrow = data === "UP" ? "▲" : "▼";
  let color =
    data === "UP"
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  return `<span style="color:${color}">${arrow}</span>`;
};

export const crossFormatter = (cell) => {
  const data = cell.getValue();

  console.log(111, data);

  let arrow = data === "L" ? "▲" : "▼";
  let color =
    data === "L"
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  return `<span style="color:${color}">${arrow}</span>`;
};

export const chartFormatter = (cell) => {
  return `
        <span class="chart-ico-formatter" style="width:32px; height:32px;display:inline-block;"></span>
    `;
};

export const xPointFormatter = ({ xPoint }) => {
  // const data = cell.getValue();

  // console.log("data", data);

  return `
        <span class="xPoint-ico-formatter" style="width:32px; height:32px;display:${
          xPoint ? "inline-block" : "none"
        };"></span>
    `;
};

export const scoreWithPriceFormatter = ({ score, price, isWithColor }) => {
  const scoreRes = Number(score);
  const priceRes = Number(price);
  let scoreColor = "";
  let priceColor = "";

  if (isWithColor) {
    scoreColor =
      scoreRes >= 0
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
    priceColor =
      priceRes >= 0
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  return `
        <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;">
            <p style="width:100%;padding-top:10px;font-size:1.7rem;color:${scoreColor};">${scoreRes.toFixed(
    1
  )}</p>
            <p style="width:100%;padding-bottom:10px;font-size:1.7rem;color:${priceColor};">$${priceRes.toFixed(
    4
  )}</p>
        </section>
    `;
};

export const kibotZonePriceFormatter = ({ score, price, isWithColor }) => {
  const scoreRes = Number(score);
  const priceRes = Number(price);
  let scoreColor = "";
  let priceColor = "";

  if (isWithColor) {
    scoreColor =
      scoreRes >= 0
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
    priceColor =
      priceRes >= 0
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  return `
        <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;">
        <p style="width:100%;padding-top:10px;font-size:1.7rem;color:${priceColor};">$${priceRes.toFixed(
    4
  )}</p>
        <p style="width:100%;padding-bottom:10px;font-size:1.7rem;color:${scoreColor};">($${scoreRes.toFixed(
    1
  )})</p>
        </section>
    `;
};

export const previousSignalFormatter = ({ signal, time, rsi, isWithColor }) => {
  let color = "";
  if (isWithColor) {
    color =
      signal[0] === "L"
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  let className = "";
  switch (rsi) {
    case "L":
      className = "long";
      break;
    case "S":
      className = "short";
      break;
  }

  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          <p class="highlight__400" style="color:${color}">${signal[0]} (${time}H)</p>
          <p class="${className} highlight__400"></p>
      </section>
    `;
};

export const kibotZoneSignalFormatter = ({ signal, time, isWithColor }) => {
  let color = "";
  let signalHtml = "";
  if (isWithColor) {
    color =
      signal[0] === "L"
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  if (signal !== "") {
    signalHtml += `<p class="highlight__400" style="color:${color}">${signal}</p>
          <p class="highlight__400" style="font-size:14px">(${time})</p>`;
  } else {
    signalHtml = `<p>-</p>`;
  }

  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          ${signalHtml}
      </section>
    `;
};

export const closeSignalFormatter = ({ signal, time }) => {
  let closeHtml = "";
  if (signal === "Close") {
    closeHtml += `<p class="highlight__400" >${signal}</p>
          <p class="highlight__400" style="font-size:14px">(${time})</p>`;
  } else {
    closeHtml = `<p>-</p>`;
  }
  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          ${closeHtml}
      </section>
    `;
};

export const kibotZonePriceVsFormatter = ({ price, isWithColor }) => {
  let color = "";
  let position = "";
  let displayPrice = price;

  const numericPrice = Number(price);

  if (isWithColor) {
    color =
      numericPrice >= 0
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");

    displayPrice = numericPrice < 0 ? price : `+${price}`;
  }

  position = numericPrice >= 0 ? "Above" : "Below";

  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap; flex-direction: row; column-gap:4px">
          <span>${position}</span><span class="highlight__400" style="color:${color}">${displayPrice}%</span>
      </section>
    `;
};

export const kibotZoneSlopeFormatter = ({ slope, isWithColor }) => {
  let color = "";
  let displaySlope = slope;

  if (isWithColor) {
    const numericSlope = Number(slope);

    if (numericSlope === 0) {
      color = getCssVariableValue("--main");
      displaySlope = 0;
    } else {
      color =
        numericSlope < 0
          ? getCssVariableValue("--red-100")
          : getCssVariableValue("--main");

      displaySlope = numericSlope < 0 ? slope : `+${slope}`;
    }
  }

  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          <p class="highlight__400" style="color:${color}">${displaySlope}º</p>
      </section>
    `;
};

export const alphaSignalFormatter = ({
  doubleSignal,
  doubleTime,
  signal,
  time,
  isWithColor,
}) => {
  let doubleColor = "";
  let color = "";
  if (isWithColor) {
    color =
      signal[0] === "L"
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");

    doubleColor =
      doubleSignal[0] === "L"
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  return `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          <p class="highlight__400" style="color:${doubleColor}">${doubleSignal} (${doubleTime}H)</p>
          <p class="highlight__400" style="color:${color}">${signal} (${time}H)</p>
      </section>
    `;
};

export const changedSignalFormatter = ({ signal, time, rsi, isWithColor }) => {
  let color = "";
  if (isWithColor) {
    color =
      signal[0] === "L"
        ? getCssVariableValue("--main")
        : getCssVariableValue("--red-100");
  }

  // console.log(signal);

  let className = "";
  switch (rsi) {
    case "L":
      className = "long";
      break;
    case "S":
      className = "short";
      break;
  }

  return signal === ""
    ? "<span>-</span>"
    : `
      <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;flex-direction: column;row-gap: 6px;">
          <p class="highlight__400" style="color:${color}">${signal[0]} (${time})</p>
          <p class="${className} highlight__400"></p>
      </section>
    `;
};

export const priceFormatter = (cell) => {
  const value = Number(cell.getValue());
  return value ? value.toFixed(4) : "";
};

export const dollarHeaderFormatter = (cell) => {
  const value = cell.getValue();

  let title;
  if (value.includes("Current")) {
    title = "Current";
  } else if (value.includes("Previous")) {
    title = "Previous";
  } else {
    title = "Fluctuating";
  }
  return `
        <p style="display: flex; flex-direction: column; justify-content: center; align-items: center;height: 64px;">
            <span>${title}</span>
            <span>Price($)</span>
        </p>
    `;
};

export const percentWithScorePrice = (cell) => {
  const data = cell.getData();
  const { s_percent, p_percent } = data;

  const scoreRes = Number(s_percent);
  const priceRes = Number(p_percent);
  const scoreColor =
    scoreRes >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const priceColor =
    priceRes >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");

  return `
        <section style="height:100% !important;display:flex; align-items:center;justify-content:center;flex-wrap:wrap;">
            <p style="width:100%;padding-top:10px;font-size:1.7rem;color:${scoreColor};">${scoreRes.toFixed(
    1
  )}%</p>
            <p style="width:100%;padding-bottom:10px;font-size:1.7rem;color:${priceColor};">${priceRes.toFixed(
    2
  )}%</p>
        </section>
    `;
};

// ================================== Mobile ==================================

export const mobileCoinFormatter = (cell) => {
  const data = cell.getData();
  const coin = data["ticker"];
  const imgSrc = cell.getData().icon;
  console.log("coin", coin);

  return `
        <section style="display: flex; align-items: center; justify-content: center; height: 100%; flex-direction: column">
            <p style="display:flex; align-items: center; padding-bottom: 5px;">
                <img src="${getImageSrc(
                  coin
                )}" alt="${coin}_icon" style="width: 17px; height: 17px"/>
                <span style="margin-left: 10px">${coin}</span>
            </p>
            <span style="white-space: pre-wrap">${data["time"]}</span>

        </section>
    `;
};

export const starTitleFormatter = (cell) => {
  return `
        <section style="display: flex; justify-content: center; align-items: center; height: 70px;">
            <span class="star" style="margin-left: 0;"></span>
        </section>
    `;
};

export const fixedLiveTitleFormatter = (cell) => {
  return `
        <section style="display: flex; justify-content: center; align-items: center; flex-direction: column; height: 70px;">
            <span>Fixed</span>
            <span>Live</span>
        </section>
    `;
};

export const valueListTitleFormatter = (cell) => {
  return `
        <section style="display: flex; align-items: center; justify-content: center; flex-direction: column;font-size: 1.4rem;height: 70px">
            <span>Current</span>
            <span>Previous</span>
            <span>Fluctuating</span>
            <span>Percent</span>
        </section>
    `;
};

/**
 * Current [price, score]
 * Previous [price, score]
 * Fluctuacting [price, score]
 * percent [price, score]
 * @param cell
 * @returns {string}
 */
export const valueListFormatter = ({
  current,
  previous,
  fluctuate,
  percent,
  isPrice,
}) => {
  const fluctuateColor =
    fluctuate >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const percentColor =
    percent >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const dollarSuffix = isPrice ? "$" : "";
  return `
        <section style="display: flex; align-items: center; justify-content: center; flex-direction: column; height: 100%;">
            <span>${current}</span>
            <span>${previous}</span>
            <span style="color: ${fluctuateColor};">${fluctuate}${dollarSuffix}</span>
            <span style="color: ${percentColor};">${percent}%</span>
        </section>
    `;
};

export const valueListWithScorePriceFormatter = (cell) => {
  const data = cell.getData();
  const currentScore = data["c_score"];
  const previousScore = data["p_score"];
  const fluctuateScore = Number(data["f_score"]);
  const percentScore = data["s_percent"];

  const currentPrice = Number(data["c_price"]).toFixed(4);
  const previousPrice = Number(data["p_price"]).toFixed(4);
  const fluctuatePrice = Number(data["f_price"]);
  const percentPrice = data["p_percent"];

  const fluctuateScoreColor =
    fluctuateScore >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const percentScoreColor =
    percentScore >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const fluctuatePriceColor =
    fluctuatePrice >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");
  const percentPriceColor =
    percentPrice >= 0
      ? getCssVariableValue("--main")
      : getCssVariableValue("--red-100");

  return `
        <section style="display: flex; align-items: center; justify-content: space-between; height: 100%;">
            <div style="display: flex; flex-direction: column; height: 100%; justify-content: center;text-align: right; margin-right: 5px;overflow: auto; width: 50%;">
                <span>${currentPrice}</span>
                <span>${previousPrice}</span>
                <span style="color: ${fluctuatePriceColor};">${fluctuatePrice.toFixed(
    4
  )}$</span>
                <span style="color: ${percentPriceColor};">${percentPrice}%</span>
            </div>
            <div style="display: flex; flex-direction: column; height: 100%; justify-content: center;text-align: right;overflow: auto; width: 50%;">
                <span>${currentScore}</span>
                <span>${previousScore}</span>
                <span style="color: ${fluctuateScoreColor};">${fluctuateScore.toFixed(
    4
  )}$</span>
                <span style="color: ${percentScoreColor};">${percentScore}%</span>
            </div>
        </section>
    `;
};

export const mobileStarFormatter = (cell) => {
  const data = cell.getData();
  // const coinArr = useUserStore().favoriteList;
  const coinArr = [];
  const isActive = coinArr.includes(data["market"]) ? "active" : "";

  return `
        <section style="height: 100%; display: flex; align-items: center; justify-content: center;">
            <div class="star ${isActive}" style="margin-left: 0;"></div>
        </section>
    `;
};

export const mobilePositionFormatter = (cell) => {
  const data = cell.getData();
  const fixed = data["fixed_signal"];
  const live = data["position"];

  const fixedPosition = getPosition(fixed);
  const livePosition = getPosition(live);

  return `
        <section style="display:flex; flex-direction: column; height: 100%; justify-content: center;">
            <span style="padding-bottom: 5px;" class="${fixedPosition} highlight__400;"></span>
            <span class="${livePosition} highlight__400;"></span>
        </section>
    `;
};

// coupon type formatting
export const couponTypeFormatter = (value) => {
  if (value === "0") return "SERVICE";
  else if (value === "1") return "DISCOUNT";
  else return value;
};

// store type formatting
export const storeTypeFormatter = (value) => {
  if (value === STORE_TYPE_NORMAL) return "NORMAL";
  else if (value === STORE_TYPE_GENERAL) return "GENERAL";
  else if (value === STORE_TYPE_STAR) return "STAR";
  else if (value === STORE_TYPE_PLANET) return "PLANET";
};
